module.exports = __webpack_public_path__ + "assets/449c88c2d45c268ee946e3a222b55b30.png";